
import { useRef } from "react";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Dialog} from "@mui/material";
import AppDialogTitle from "./appDialogTitle";

function DraggablePaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog"
        >
            <Paper 
            id="draggable-dialog" ref={nodeRef} {...props} />
        </Draggable>
    );
}

export default function DraggableDialog({
    open,
    onClose,
    children,
    title,
    width
}) {

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth={width || 'xs'} PaperComponent={DraggablePaperComponent} >
            <AppDialogTitle onClose={onClose} title={title} sx={{cursor: 'move'}} />
            {children}
        </Dialog>
    )
}